import DatePicker from '@components/common/DatePicker';
import LabelT from '@components/tailwind-components/Label/LabelT';
import { startOfDay } from 'date-fns';
import type React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ExpiryDatePickerSectionProps {
  id?: string;
  expiryDate: Date | null;
  onChange: (date: Date | null) => void;
  isTargetTemporary: boolean;
}

export const ExpiryDatePickerSection: React.FC<
  ExpiryDatePickerSectionProps
> = ({ id = 'expiry-date', expiryDate, onChange, isTargetTemporary }) => {
  const { t } = useTranslation();
  const today = useMemo(() => startOfDay(new Date()), []);

  return (
    <div>
      <LabelT
        htmlFor={id}
        text={t('data-sources.expiry.label')}
        subText={isTargetTemporary ? '*' : undefined}
        subTextClassName='!text-red-500'
        className={`block text-xs leading-6 cursor-inherit font-medium${!isTargetTemporary ? ' !text-gray-400' : ' text-gray-600'}`}
      />
      <div className='mt-1'>
        <DatePicker
          id={id}
          selected={expiryDate}
          onChange={onChange}
          minDate={today}
          disabled={!isTargetTemporary}
          dateFormat='dd/MM/yyyy'
          popperPlacement='bottom-start'
          wrapperClassName='w-full'
          className={`block rounded-md py-1.5 px-2.5 text-xs leading-5 font-normal text-gray-600 ring-1 ring-inset ring-gray-200 focus:ring-1 focus:ring-inset focus:ring-primary-base w-full${
            !isTargetTemporary
              ? ' bg-gray-100 opacity-70 cursor-not-allowed'
              : ''
          }`}
        />
        {isTargetTemporary && (
          <p className='mt-1 text-xs text-amber-600'>
            * {t('data-sources.expiry.required-hint')}
          </p>
        )}
      </div>
    </div>
  );
};
